module.exports = __webpack_public_path__ + "f4c8586184f2c56e41bdd2c2803d29a8.pdf";